import { render, staticRenderFns } from "./listDeclaration.vue?vue&type=template&id=0a04a46c&scoped=true&"
import script from "./listDeclaration.vue?vue&type=script&lang=js&"
export * from "./listDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./listDeclaration.vue?vue&type=style&index=0&id=0a04a46c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a04a46c",
  null
  
)

export default component.exports